<template>
    <!-- Inner content -->
    <div class="inner-content">
        <section>
            <div class="container-fluid">
                <div class="row m-0">
                    <div class="col-12">
                        <div class="card">
                            <div
                                class="card-header card-header-primary d-flex flex-wrap align-items-center position-relative py-4">
                                <div class="content-card-left">
                                    <h4 class="card-title text-white">Inventory Out</h4>
                                </div>
                                <div class="content-card-right ms-auto d-flex align-items-center">
                                    <router-link to="/payment/add"
                                        class="btn btn-add btn-add-lg d-flex flex-wrap align-items-center justify-content-center rounded-circle">
                                        <i class="bi bi-plus-square-fill text-white"></i>
                                    </router-link>
                                <!-- </div>
                                <div class="content-card-right ms-auto"> -->
                                    <a href="#AddShopTransaction" data-bs-toggle="modal" data-bs-target="#AddShopTransaction"
                                        @click.prevent
                                        class="btn btn-add d-flex flex-wrap align-items-center justify-content-center rounded-circle">
                                        <i class="bi bi-cash text-white"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="card-body px-0">
                                <div class="header-content">
                                    <Form @submit="onSubmit" :validation-schema="schema"
                                        class="custom-form mt-2 shops-product" ref="myForm">
                                        <div class="row mx-0 px-4">
                                            <div class="col-lg-11 col-md-11 col-sm-10 col-9">
                                                <div class="position-relative form-group">
                                                    <Field as="select" name="salesman_id"
                                                        class="form-select custom-select" @click="selectFocus = true"
                                                        v-model="salesman_id">
                                                        <option value="0">Choose Salesman</option>
                                                        <option v-for="salesman in salesmen" :value="salesman.id"
                                                            :key="salesman.id">{{ salesman.first_name + ""+salesman.last_name}}</option>

                                                    </Field>
                                                    <label
                                                        :class="[selectFocus ? 'focus' : '', 'position-absolute select-label']">Salesman</label>
                                                    <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                                    <ErrorMessage class="invalid-message mb-0 pt-2"
                                                        name="salesman_id" />
                                                    <p v-if="errors_v.get('salesmanId') && (salesman_id == null || salesman_id == '')"
                                                        class="invalid-message mb-0 pt-2">
                                                        {{ errors_v.get('salesmanId') }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-lg-1 col-md-1 col-sm-2  col-3 align-self-center">
                                                <a href="#"
                                                    class="d-flex flex-wrap align-items-center justify-content-center hover-btn rounded-circle ms-auto"
                                                    @click.prevent>
                                                    <i class="bi bi-arrow-repeat"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="row mx-0 px-4 mt-4">
                                            <div class="col-lg-11 col-md-11 col-sm-10 col-9">
                                                <div class="position-relative form-group">
                                                    <Field as="select" name="sale_type"
                                                        class="form-select custom-select" @click="selectFocus = true"
                                                        v-model="sale_type" @change="resetCustomForm">
                                                        <option value="0">Choose Sale Type</option>
                                                        <option value="retail">Retail</option>
                                                        <option value="wholesale">Wholesale</option>
                                                        <option value="initial">Initial</option>
                                                        <option value="middle">Middle</option>

                                                    </Field>
                                                    <label
                                                        :class="[selectFocus ? 'focus' : '', 'position-absolute select-label']">Sale
                                                        Type</label>
                                                    <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                                    <ErrorMessage class="invalid-message mb-0 pt-2" name="sale_type" />
                                                    <p v-if="errors_v.get('saleType') && (sale_type == null || sale_type == '')"
                                                        class="invalid-message mb-0 pt-2">
                                                        {{ errors_v.get('saleType') }}
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="row mx-0 px-4 mt-4" v-if="sale_type === 'initial'">
                                            <div class="col-lg-11 col-md-11 col-sm-10 col-9">
                                                <div class="position-relative form-group">
                                                    <Field as="select" name="company_id"
                                                        class="form-select custom-select"
                                                        @click="selectFocus = true" v-model="company_id"
                                                        @change="resetCustomForm">
                                                        <option value="">Choose Company</option>
                                                        <option v-for="c in companies" :key="c.id" :value="c.id">{{ c.name }}</option>
                                                    </Field>
                                                    <label
                                                        :class="[selectFocus ? 'focus' : '', 'position-absolute select-label']">Company</label>
                                                    <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                                    <ErrorMessage class="invalid-message mb-0 pt-2" name="company_id" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mx-0 px-4 mt-4" v-if="sale_type === 'initial' || sale_type === 'middle'">
                                            <div class="col-lg-11 col-md-11 col-sm-10 col-9">
                                                <div class="position-relative form-group">
                                                    <select class="form-select custom-select"
                                                        @click="selectFocus = true" v-model="billing_date">
                                                        <option value="">Choose Date</option>
                                                        <option v-for="opt in dateOptions" :key="opt.value"
                                                            :value="opt.value">{{ opt.label }}</option>
                                                    </select>
                                                    <label
                                                        :class="[selectFocus ? 'focus' : '', 'position-absolute select-label']">Billing
                                                        Date</label>
                                                    <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Shop rows -->
                                        <fieldset class="InputGroup row mx-0 shop-row mt-4 pt-3 pb-4"
                                            v-for="(shop, idx) in shops" :key="shop.id">

                                            <div class="col-12 px-0">
                                                <div class="row mx-0 px-4 gy-4">
                                                    <div class="col-12" v-if="idx === 0">
                                                        <div class="d-flex flex-wrap align-items-center mb-2">
                                                            <h6 class="mb-0 text-primary">Shop#{{ idx + 1 }}</h6>
                                                            <div class="text-center add-rows-wrapper ms-auto">
                                                                <span
                                                                    class="d-inline-block add bi bi-plus-circle-fill text-primary"
                                                                    @click="add_shop"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12" v-else>
                                                        <div class="d-flex flex-wrap align-items-center mb-2">
                                                            <h6 class="mb-0 text-primary">Shop#{{ idx + 1 }}</h6>
                                                            <div class="text-center add-rows-wrapper ms-auto">
                                                                <span
                                                                    class="d-inline-block add bi bi-dash-circle-fill text-primary"
                                                                    @click="remove_shop(shop)"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-md-6">
                                                        <Multiselect
                                                            @select="changeMultiselectShop(shop.shop_model, idx)"
                                                            v-model="shop.shop_model" :options="shopOptions"
                                                            class="custom-multiselect" placeholder="Shop"
                                                            :searchable="true" :showOptions="true" mode="single"
                                                            label="shopName" trackBy="shop_name" valueProp="id"
                                                            required: true :id="`multiselect_${idx}`"
                                                            :name="`shops[${idx}].multiselect`" />
                                                        <Field type="hidden" :id="`shopid_${idx}`"
                                                            :name="`shops[${idx}].shopid`"
                                                            v-model="values_hidden_shops[idx]" />
                                                        <p v-if="errors_v.get('billingData.' + idx + '.shopid') && (values_hidden_shops[idx] == null || values_hidden_shops[idx] == '')"
                                                            class="invalid-message mb-0 pt-2">
                                                            {{ errors_v.get('billingData.' + idx + '.shopid') }}
                                                        </p>
                                                        <ErrorMessage class="invalid-message mb-0 pt-2"
                                                            :name="`shops[${idx}].shopid`" />
                                                    </div>
                                                    <div class="col-xl-3 col-md-6">
                                                        <div class="position-relative">
                                                            <Field type="number" :id="`discount_${idx}`"
                                                                :name="`shops[${idx}].discount`"
                                                                :class="[shop.discount == '' ? '' : 'active', 'border-input position-relative w-100']"
                                                                v-model="shop.discount" />
                                                            <label for=""
                                                                class="mb-0 placeholder-label w-auto">Discount</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-md-6">
                                                        <div class="position-relative">
                                                            <Field type="number" :id="`freight_${idx}`"
                                                                :name="`shops[${idx}].freight`"
                                                                :class="[shop.freight == '' ? '' : 'active', 'border-input position-relative w-100']"
                                                                v-model="shop.freight" />
                                                            <label for=""
                                                                class="mb-0 placeholder-label w-auto">Freight</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-md-6">
                                                        <div class="position-relative">
                                                            <Field type="number" :id="`amount_${idx}`"
                                                                :name="`shops[${idx}].amount`"
                                                                :class="[shop.amount == '' ? '' : 'active', 'border-input position-relative w-100']"
                                                                v-model="shop.amount" />
                                                            <label for=""
                                                                class="mb-0 placeholder-label w-auto">Amount</label>
                                                            <!-- Shown once a shop is picked and its balance (with this salesman) has loaded -->
                                                            <p v-if="shop.shop_model && shop.prev_balance !== null" class="invalid-message mb-0 pt-2">
                                                                <span>prev balance: {{ shop.prev_balance }} </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-md-6">
                                                        <div class="position-relative">
                                                            <Field type="text" :id="`payment_type_${idx}`"
                                                                :name="`shops[${idx}].payment_type`"
                                                                :class="[shop.payment_type == '' ? '' : 'active', 'border-input position-relative w-100']"
                                                                v-model="shop.payment_type" />
                                                            <label for=""
                                                                class="mb-0 placeholder-label w-auto">Payment</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <fieldset class="InputGroup row mx-0"
                                                    v-for="(product, pdx) in shop.products" :key="product.id">
                                                    <!-- Products row -->
                                                    <div class="row mx-0 px-4 product-row mt-3 gy-4">
                                                        <div class="col-12" v-if="pdx === 0">
                                                            <div
                                                                class="d-flex flex-wrap align-items-center mb-2 justify-content-between">
                                                                <h6 class="mb-0 text-primary">Product#{{ pdx + 1 }}</h6>
                                                                <div class="text-center d-flex align-items-center me-2">
                                                                    <div
                                                                        class="d-flex flex-column justify-content-start align-items-start">
                                                                        <label>Add Bulk Products</label>
                                                                        <input type="number" min="0"
                                                                            class="form-control form-control-sm w-auto me-2"
                                                                            v-model.number="shop.addCount"
                                                                            placeholder="0"
                                                                            @keyup.enter.prevent="bulkAddProducts(idx)"
                                                                            :ref="el => setAddCountRef(idx, el)" />

                                                                    </div>
                                                                    <span
                                                                        class="d-inline-block add bi bi-plus-circle-fill text-primary add-rows-wrapper"
                                                                        @click="bulkAddProducts(idx)"
                                                                        style="font-size: 23px;"></span>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12" v-else>
                                                            <div class="d-flex flex-wrap align-items-center mb-2">
                                                                <h6 class="mb-0 text-primary">Product#{{ pdx + 1 }}</h6>
                                                                <div class="text-center add-rows-wrapper ms-auto">
                                                                    <span
                                                                        class="d-inline-block add bi bi-dash-circle-fill text-primary"
                                                                        @click="remove_product(idx, pdx)"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-md-6">
                                                            <Multiselect
                                                                @select="changeMultiselectProduct(shop.products[pdx].pmodel, idx, pdx)"
                                                                v-model="shop.products[pdx].pmodel"
                                                                :options="filteredProductOptions" class="custom-multiselect"
                                                                placeholder="Products" :searchable="true"
                                                                :showOptions="true" mode="single" label="name"
                                                                trackBy="name" valueProp="id" required: true
                                                                :id="`multiselect_${idx}`"
                                                                :name="`shops[${idx}].products_multiselect`" />
                                                            <Field type="hidden" :id="`hidden_val_${pdx}`"
                                                                :name="`shops[${idx}].products[${pdx}].hidden_val`"
                                                                v-model="product.hidden_val" :key="pdx" />
                                                            <p v-if="errors_v.get('billingData.' + idx + '.products.' + pdx + '.hidden_val') && (shops[idx].products[pdx].hidden_val == null || shops[idx].products[pdx].hidden_val == '')"
                                                                class="invalid-message mb-0 pt-2">
                                                                {{ errors_v.get('billingData.' + idx + '.products.' + pdx + '.hidden_val') }}
                                                            </p>
                                                            <ErrorMessage class="invalid-message mb-0 pt-2"
                                                                :name="`shops[${idx}].products[${pdx}].hidden_val`" />
                                                        </div>
                                                        <div class="col-xl-3 col-md-6">
                                                            <div class="position-relative form-group">
                                                                <Field as="select" :id="`ptype_${pdx}`"
                                                                    :name="`shops[${idx}].products[${pdx}].ptype`"
                                                                    class="form-select custom-select"
                                                                    @click="selectFocus = true" v-model="product.ptype"
                                                                    :key="pdx" @change="updateTotalAmount(idx, pdx)">
                                                                    <option value="boxes">Boxes</option>
                                                                    <option value="cartons">Cartons</option>
                                                                </Field>
                                                                <label
                                                                    :class="[selectFocus ? 'focus' : '', 'position-absolute select-label']">Quantity
                                                                    In</label>
                                                                <i
                                                                    class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-md-6">
                                                            <div class="position-relative">
                                                                <Field type="number" :id="`quantity_${idx}_${pdx}`"
                                                                    :name="`shops[${idx}].products[${pdx}].quantity`"
                                                                    :key="pdx"
                                                                    :class="[shops[idx].products[pdx].quantity == '' ? '' : 'active', 'border-input position-relative w-100']"
                                                                    v-model="product.quantity"
                                                                    @change="updateTotalAmount(idx, pdx)" />
                                                                <label for=""
                                                                    class="mb-0 placeholder-label w-auto">Quantity</label>
                                                                <p v-if="errors_v.get('billingData.' + idx + '.products.' + pdx + '.quantity')"
                                                                    class="invalid-message mb-0 pt-2">
                                                                    {{ errors_v.get('billingData.' + idx + '.products.' + pdx + '.quantity') }}
                                                                </p>
                                                                <ErrorMessage class="invalid-message mb-0 pt-2"
                                                                    :name="`shops[${idx}].products[${pdx}].quantity`" />
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-md-6" v-if="sale_type === 'initial'">
                                                            <div class="position-relative">
                                                                <Field type="number" min="0" :id="`pdiscount_${idx}_${pdx}`"
                                                                    :name="`shops[${idx}].products[${pdx}].discount`"
                                                                    :class="[product.discount === '' ? '' : 'active', 'border-input position-relative w-100']"
                                                                    v-model="product.discount"
                                                                    @input="onDiscountInput($event, idx, pdx)" />
                                                                <label for=""
                                                                    class="mb-0 placeholder-label w-auto">Discount</label>
                                                                <ErrorMessage class="invalid-message mb-0 pt-2"
                                                                    :name="`shops[${idx}].products[${pdx}].discount`" />
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-md-6" v-if="sale_type === 'initial'">
                                                            <div class="position-relative form-group">
                                                                <Field as="select" :id="`pdtype_${idx}_${pdx}`"
                                                                    :name="`shops[${idx}].products[${pdx}].discount_type`"
                                                                    class="form-select custom-select"
                                                                    v-model="product.discount_type"
                                                                    @change="updateTotalAmount(idx, pdx)">
                                                                    <option value="price">Price (Rs)</option>
                                                                    <option value="percent">Percent (%)</option>
                                                                </Field>
                                                                <label
                                                                    :class="[selectFocus ? 'focus' : '', 'position-absolute select-label']">Discount
                                                                    Type</label>
                                                                <i
                                                                    class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-md-6">
                                                            <div class="position-relative">
                                                                <input type="text"
                                                                    :name="`shops[${idx}].products[${pdx}].total_amount`"
                                                                    class='active border-input position-relative w-100'
                                                                    v-model="product.total_amount" disabled />
                                                                <label for=""
                                                                    class="mb-0 placeholder-label w-auto">Amount:
                                                                </label>


                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <div class="row mx-0 px-4 mt-5">
                                                    <div class="col-auto ms-auto">
                                                        <div class="position-relative">
                                                            <input type="text"
                                                                class='active border-input position-relative w-100'
                                                                v-model="shops[idx].total_amount" disabled />
                                                            <label for="" class="mb-0 placeholder-label w-auto">Total
                                                                Amount: </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </fieldset>
                                        <div class="card-footer px-4 pb-0 border-0 bg-transparent mb-3">
                                            <button class="btn btn-primary w-100"
                                                :disabled="searchDisabled || (isEdit && editLocked)">
                                                <div v-if="loader" class="spinner-border me-2" role="status"></div>{{
                                                isEdit ? 'Update Billing' : 'Add Billing' }}
                                            </button>
                                            <p v-if="isEdit && editLocked" class="text-danger text-center mt-2 small">
                                                Editing disabled: only once within 24 hours.</p>
                                        </div>
                                    </Form>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <add-credit @alert-event="showGrowl"></add-credit>
    <AddShopTransaction/>
    <Alert v-if="growlMessage" :name="alert_m.name" :alertHeading="alert_m.heading"
        :alertDescription="alert_m.description">
    </Alert>
</template>
<script>
import { ref, reactive, onMounted, watch, nextTick, computed } from 'vue';
import "@/assets/scss/pages/_add-billing.scss";
// Add this for multiselect
import Multiselect from '@vueform/multiselect';
import "@vueform/multiselect/themes/default.css";
import salesmanServices from '@/services/SalesmanServices';
import salesmanShopServices from '@/services/SalesmanShopServices';
import billingServices from '@/services/BillingServices';
import productServices from '@/services/ProductServices';
import companyServices from '@/services/CompanyServices';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Errors from "@/utils/Errors";
import * as yup from "yup";
import { useRouter, useRoute } from "vue-router";
import BalanceSheetServices from '@/services/BalanceSheetServices';
import AddCredit from '@/components/modals/AddCreditModal.vue';
import Alert from "@/components/alert";
import AddShopTransaction from '@/components/modals/AddShopTransaction.vue';
import moment from 'moment';
export default {
    components: {
        Multiselect,
        Form,
        Field,
        ErrorMessage,
        AddCredit,
        Alert,
        AddShopTransaction
    },
    setup() {
        const salesmen = ref([]);
        const salesman_id = ref(0);
        const sale_type = ref("");
        // Not pre-selected: the user picks a billing date, otherwise it bills as today.
        const billing_date = ref("");
        // Billing date can only be one of the last 4 dates (today + previous 3 days).
        const dateOptions = computed(() => {
            const opts = [];
            for (let i = 0; i < 4; i++) {
                const d = moment().subtract(i, 'days');
                opts.push({ value: d.format('YYYY-MM-DD'), label: d.format('DD/MM/YY') });
            }
            // When editing an older billing, keep its date selectable so the dropdown isn't blank.
            if (billing_date.value && !opts.some((o) => o.value === billing_date.value)) {
                opts.push({ value: billing_date.value, label: moment(billing_date.value).format('DD/MM/YY') });
            }
            return opts;
        });
        const shopOptions = ref("");
        const productOptions = ref([]);
        // Company filter (only used for the "initial" sale type): narrows the product
        // dropdown to a single company's products. Products carry their own company_id,
        // so the filtering itself is client-side. The company list is fetched lazily
        // (only when "initial" is selected) via the paginated companies endpoint.
        const companies = ref([]);
        const company_id = ref("");
        // Default packing unit for a newly-added product: "initial" and "middle"
        // sales move stock by the carton, so their products default to cartons;
        // every other sale type defaults to boxes.
        const defaultPtype = () =>
            (sale_type.value === 'initial' || sale_type.value === 'middle') ? 'cartons' : 'boxes';
        // Fetch the company list once, on demand. Uses the existing paginated
        // companies endpoint with a large page size so all companies come back in
        // one call. Called only for the "initial" sale type.
        const loadCompanies = async () => {
            if (companies.value.length) return;
            try {
                const response = await companyServices.paginateCompanies(2000);
                companies.value = response.data && Array.isArray(response.data.data)
                    ? response.data.data
                    : [];
            } catch (e) {
                companies.value = [];
            }
        };
        const filteredProductOptions = computed(() => {
            if (sale_type.value === 'initial' && company_id.value) {
                return productOptions.value.filter(
                    (p) => Number(p.company_id) === Number(company_id.value)
                );
            }
            return productOptions.value;
        });
        // Reset the company filter whenever the sale type changes, and lazily load
        // the company list the first time "initial" is selected.
        watch(sale_type, (val) => {
            company_id.value = "";
            if (val === 'initial') loadCompanies();
        });
        const loader = ref(false);
        const router = useRouter();
        const route = useRoute();
        const isEdit = ref(false);
        const billingId = ref(null);
        const searchDisabled = ref(false);
        const editLocked = ref(false);
        const myForm = ref(null);
        // Debounce configuration and timers (declared before use)
        const bulkAddDelay = 2000; // ms
        const bulkTimers = ref([]);
        const alert_m = reactive({
            name: '',
            heading: '',
            description: ''
        });
        const growlMessage = ref(false);
        const showGrowl = (alertType) => {
            if (alertType == "add") {
                alert_m.name = "success";
                alert_m.description = "Record Added Successfully";
            }
            else if (alertType == "edit") {
                alert_m.name = "success";
                alert_m.description = "Record Updated Successfully";
            }
            else {
                alert_m.name = "danger";
                alert_m.description = "No Record Found. Please try with valid data";
            }


            alert_m.heading = "Credit";
            growlMessage.value = true;
            setTimeout(() => { growlMessage.value = false; }, 5000)
        }
        // Show a custom danger message in the growl (e.g. the duplicate-billing conflict).
        const showErrorGrowl = (message, heading = "Billing") => {
            alert_m.name = "danger";
            alert_m.heading = heading;
            alert_m.description = message;
            growlMessage.value = true;
            setTimeout(() => { growlMessage.value = false; }, 5000)
        }
        const shops = ref([{
            id: Date.now(),
            shop_model: "",
            discount: "",
            freight: "",
            amount: "",
            payment_type: "",
            prev_balance: null,
            total_amount: "",
            addCount: 0,
            lastBulkTrigger: null,
            products: [{
                id: Date.now(),
                pmodel: "",
                ptype: defaultPtype(),
                quantity: "",
                hidden_val: "",
                total_amount: "",
                discount: "",
                discount_type: 'price'
            }]
        }]);
        const errors_v = reactive(new Errors());
        const values_hidden_shops = ref({});
        const schema = yup.object().shape({
            salesman_id: yup.number().moreThan(0, 'Salesman Required'),
            sale_type: yup.string().required().label("Sale Type"),
            // Company is required only for the "initial" sale type (the only case
            // where the field is rendered). For other sale types it stays optional.
            company_id: yup.string().when('sale_type', {
                is: 'initial',
                then: (s) => s.required('Company Required'),
                otherwise: (s) => s.nullable(),
            }),
            shops: yup
                .array()
                .of(
                    yup.object().shape({
                        shopid: yup.number().required().label("Shop Name"),
                        products: yup.array()
                            .of(
                                yup.object().shape({
                                    hidden_val: yup.number().moreThan(0, 'Product Name Required').typeError("Product Name Required").label("Quantity"),
                                    quantity: yup.number().moreThan(0, 'Product Quantity Required').typeError("Only Numbers Allowed").label("Quantity"),
                                    discount_type: yup.string().nullable(),
                                    discount: yup
                                        .number()
                                        .transform((v, o) => (o === '' || o === null ? undefined : v))
                                        .typeError('Only Numbers Allowed')
                                        .min(0, 'Discount cannot be negative')
                                        .when('discount_type', {
                                            is: 'percent',
                                            then: (s) => s.max(100, 'Percentage cannot be more than 100%'),
                                        })
                                        .test(
                                            'not-above-amount',
                                            'Discount cannot be more than amount',
                                            function (value) {
                                                if (value == null) return true;
                                                if (this.parent.discount_type !== 'price') return true;
                                                const obj = productOptions.value.find(
                                                    (o) => Number(o.id) === Number(this.parent.hidden_val)
                                                );
                                                if (!obj) return true;
                                                let qty = Number(this.parent.quantity) || 0;
                                                if (this.parent.ptype === 'cartons') {
                                                    qty = qty * (Number(obj.boxes_per_carton) || 0);
                                                }
                                                const gross = (Number(obj.initial_price_per_unit) || 0) * qty;
                                                if (value <= gross) return true;
                                                return this.createError({
                                                    message: `Discount cannot be more than amount (${gross.toFixed(2)})`,
                                                });
                                            }
                                        )
                                        .nullable(),
                                })
                            )
                    })
                )

        });
        const add_shop = () => {
            shops.value.push({
                id: Date.now(),
                shop_model: "",
                discount: "",
                freight: "",
                amount: "",
                payment_type: "",
                prev_balance: null,
                total_amount: "",
                addCount: 0,
                lastBulkTrigger: null,
                products: [{
                    id: Date.now(),
                    pmodel: "",
                    ptype: defaultPtype(),
                    quantity: "",
                    total_amount: "",
                    hidden_val: "",
                    discount: "",
                    discount_type: 'price'
                }]
            });
        }

        const remove_shop = (item) => {
            const index = shops.value.indexOf(item);
            if (index === -1) {
                return;
            }
            shops.value.splice(index, 1);
        }

        const add_product = (idx, count = 1) => {
            const toAdd = Math.max(1, parseInt(count) || 1);
            for (let i = 0; i < toAdd; i++) {
                shops.value[idx].products.push({
                    id: Date.now() + i,
                    pmodel: "",
                    ptype: defaultPtype(),
                    quantity: "",
                    total_amount: "",
                    hidden_val: "",
                    discount: "",
                    discount_type: 'price',
                });
            }
            shops.value[idx].addCount = 0;
        }

        const remove_product = (idx, pdx) => {
            if (pdx < 0 || pdx >= shops.value[idx].products.length) return;
            shops.value[idx].products.splice(pdx, 1);
            const shopTotal = shops.value[idx].products.reduce((sum, product) => {
                const lineTotal = Number(product.total_amount) || 0;
                return sum + lineTotal;
            }, 0);
            shops.value[idx].total_amount = shopTotal.toFixed(2);
        }

        const updateTotalAmount = (idx, pdx) => {

            if (idx >= 0 && pdx >= 0) {

                const product_id = shops.value[idx].products[pdx].hidden_val;
                const numericProductId = Number(product_id);
                const obj = productOptions.value.find(o => Number(o.id) === numericProductId);
                if (!obj) {
                    shops.value[idx].products[pdx].total_amount = '';
                    const fallbackTotal = shops.value[idx].products.reduce((sum, product) => sum + (Number(product.total_amount) || 0), 0);
                    shops.value[idx].total_amount = fallbackTotal.toFixed(2);
                    return;
                }
                let quantity = Number(shops.value[idx].products[pdx].quantity) || 0;
                const ptype = shops.value[idx].products[pdx].ptype;
                if (ptype === "cartons") {
                    const boxesPerCarton = Number(obj.boxes_per_carton) || 0;
                    quantity = quantity * boxesPerCarton;
                }
                if (numericProductId > 0 && quantity > 0 && sale_type.value != "") {
                    let unitPrice = 0;
                    if (sale_type.value === "retail") {
                        unitPrice = Number(obj.retail_price) || 0;
                    }
                    else if (sale_type.value === "wholesale") {
                        unitPrice = Number(obj.whole_sale_price) || 0;
                    }
                    else if (sale_type.value === "middle") {
                        unitPrice = Number(obj.middle_price_per_unit) || 0;
                    }
                    else {
                        unitPrice = Number(obj.initial_price_per_unit) || 0;
                    }
                    let lineTotal = unitPrice * quantity;
                    const gross = lineTotal;
                    // Per-product discount applies only to "initial" sale type.
                    // Limits (percent <= 100, price <= amount) are enforced by the Yup schema;
                    // here we just cap the preview so the displayed amount never goes negative.
                    if (sale_type.value === "initial") {
                        const prod = shops.value[idx].products[pdx];
                        const dVal = Number(prod.discount) || 0;
                        if (dVal > 0) {
                            if (prod.discount_type === "percent") {
                                lineTotal = lineTotal - (lineTotal * Math.min(dVal, 100) / 100);
                            } else {
                                lineTotal = Math.max(0, lineTotal - Math.min(dVal, gross));
                            }
                        }
                    }
                    shops.value[idx].products[pdx].total_amount = lineTotal.toFixed(2);
                } else {
                    shops.value[idx].products[pdx].total_amount = '';
                }
                const shopTotal = shops.value[idx].products.reduce((sum, product) => {
                    const lineTotal = Number(product.total_amount) || 0;
                    return sum + lineTotal;
                }, 0);
                shops.value[idx].total_amount = shopTotal.toFixed(2);
            }
        }

        // Discount input: write the fresh value from the DOM event BEFORE recalculating,
        // otherwise updateTotalAmount reads the previous (not-yet-synced) v-model value.
        const onDiscountInput = (event, idx, pdx) => {
            shops.value[idx].products[pdx].discount = event.target.value;
            updateTotalAmount(idx, pdx);
        }



        const focusFirstQuantityError = (errorBag) => {
            try {
                if (!errorBag) {
                    return;
                }
                const errorKeys = Object.keys(errorBag);
                const quantityField = errorKeys.find(key => key.includes('.quantity'));
                if (!quantityField) {
                    return;
                }
                const matches = quantityField.match(/billingData\.(\d+)\.products\.(\d+)\.quantity/);
                if (!matches) {
                    return;
                }
                const [, shopIdx, productIdx] = matches;
                nextTick(() => {
                    const el = document.getElementById(`quantity_${shopIdx}_${productIdx}`);
                    if (el) {
                        try {
                            el.focus({ preventScroll: true });
                        } catch (err) {
                            el.focus();
                        }
                        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                });
            } catch (e) {
                // ignore focus errors
            }
        }

        async function changeMultiselectShop(value, idx) {
            shops.value[idx].prev_balance = null;
            await BalanceSheetServices.getPrevBalance(value, salesman_id.value)
                .then(response => {
                    shops.value[idx].prev_balance = response.data.remaining_amount;
                })
            values_hidden_shops.value[idx] = value;
        }

        function changeMultiselectProduct(value, idx, pdx) {
            if (!shops.value[idx] || !shops.value[idx].products || !shops.value[idx].products[pdx]) return;
            shops.value[idx].products[pdx].hidden_val = value;
            updateTotalAmount(idx, pdx);
        }


        function resetCustomForm() {
            // Clear any pending bulk timers
            if (Array.isArray(bulkTimers.value)) {
                bulkTimers.value.forEach((t, i) => {
                    if (t) clearTimeout(t);
                    bulkTimers.value[i] = null;
                });
            }
            // Reset shops to a single clean entry with bulk fields
            shops.value.length = 0;
            shops.value = [{
                id: Date.now(),
                shop_model: "",
                discount: "",
                freight: "",
                amount: "",
                payment_type: "",
                prev_balance: null,
                total_amount: "",
                addCount: 0,
                lastBulkTrigger: null,
                products: [{
                    id: Date.now(),
                    pmodel: "",
                    ptype: defaultPtype(),
                    quantity: "",
                    hidden_val: "",
                    total_amount: "",
                    discount: "",
                    discount_type: 'price'
                }]
            }];
            values_hidden_shops.value = {};
            // Reset vee-validate form state to match
            if (myForm.value && typeof myForm.value.resetForm === 'function') {
                myForm.value.resetForm({
                    values: {
                        salesman_id: salesman_id.value || 0,
                        sale_type: sale_type.value || "",
                        company_id: company_id.value || "",
                        shops: [
                            {
                                shopid: "",
                                discount: "",
                                amount: "",
                                payment_type: "",
                                products: [
                                    {
                                        hidden_val: "",
                                        quantity: "",
                                        ptype: defaultPtype()
                                    }
                                ]
                            }
                        ]
                    }
                });
            }
        }

        const addCountRefs = ref([]);
        const setAddCountRef = (idx, el) => {
            addCountRefs.value[idx] = el;
        }



        function bulkAddProducts(idx) {
            // clear any pending scheduled run for this shop
            if (bulkTimers.value[idx]) {
                clearTimeout(bulkTimers.value[idx]);
                bulkTimers.value[idx] = null;
            }
            const raw = parseInt(shops.value[idx].addCount, 10) || 0;
            const count = Math.min(Math.max(raw, 0), 100);
            const safeCount = isNaN(count) || count < 1 ? 1 : count;
            add_product(idx, safeCount);
            shops.value[idx].lastBulkTrigger = safeCount;
            nextTick(() => {
                const el = addCountRefs.value[idx];
                if (el && typeof el.focus === 'function') el.focus();
            });
        }

        // Debounce support for auto bulk add
        const scheduleBulkAdd = (idx) => {
            if (bulkTimers.value[idx]) {
                clearTimeout(bulkTimers.value[idx]);
            }
            bulkTimers.value[idx] = setTimeout(() => {
                bulkAddProducts(idx);
            }, bulkAddDelay);
        }

        // Watch only the addCount values per shop to auto-add without pressing Enter
        watch(
            () => shops.value.map(s => s && s.addCount),
            (newVals, oldVals) => {
                newVals.forEach((newVal, idx) => {
                    const parsedNew = parseInt(newVal);
                    const parsedOld = oldVals && oldVals[idx] !== undefined ? parseInt(oldVals[idx]) : undefined;
                    const shop = shops.value[idx];
                    if (!shop) return;
                    // Auto-add when value reaches 1 or more, not just >1
                    if (!isNaN(parsedNew) && parsedNew >= 1 && parsedNew !== parsedOld && parsedNew !== shop.lastBulkTrigger) {
                        // schedule rather than immediate run
                        scheduleBulkAdd(idx);
                    }
                });
            }
        );

        watch(() => salesman_id.value, (currentValue, oldValue) => {
            if (currentValue != oldValue && currentValue != "") {
                salesmanShopServices.getSalesmanShops(salesman_id.value)
                    .then(response => {
                        console.log(response.data.data);
                        shopOptions.value = response.data.data;

                    })
                resetCustomForm();

            }
        });

        onMounted(async () => {
            await salesmanServices.paginateSalesman()
                .then(response => {
                    salesmen.value = response.data.data;
                })

            await productServices.getAllProducts()
                .then(response => {
                    const raw = response && response.data ? response.data : [];
                    const data = Array.isArray(raw)
                        ? raw
                        : (raw && Array.isArray(raw.data) ? raw.data : []);
                    productOptions.value = data;
                })

            // Companies are loaded lazily — only when the "initial" sale type is
            // chosen (see loadCompanies / the sale_type watch below).

            // Detect edit mode and prefill
            if (route.params.billing_id) {
                isEdit.value = true;
                billingId.value = route.params.billing_id;
                try {
                    const resp = await billingServices.getOneBillDetail(billingId.value);
                    const meta = resp.data && resp.data.billingMeta ? resp.data.billingMeta : null;
                    if (meta) {
                        if (typeof meta.editable !== 'undefined') {
                            editLocked.value = !meta.editable;
                        }
                        // Set salesman and sale type; load shops for salesman
                        salesman_id.value = meta.salesman_id;
                        sale_type.value = meta.sale_type || '';
                        if (meta.created_at) billing_date.value = moment(meta.created_at).format('YYYY-MM-DD');
                        const shopsRes = await salesmanShopServices.getSalesmanShops(salesman_id.value);
                        shopOptions.value = shopsRes.data.data;
                    }
                    const items = resp.data && resp.data.data ? resp.data.data : [];
                    // Build shops/products structure
                    shops.value = [];
                    values_hidden_shops.value = {};
                    for (let i = 0; i < items.length; i++) {
                        const row = items[i];
                        const shopId = row.shop_id;
                        const details = row.details || [];
                        const newShop = {
                            id: Date.now() + i,
                            shop_model: shopId,
                            discount: '',
                            freight: '',
                            amount: '',
                            payment_type: '',
                            prev_balance: null,
                            total_amount: '',
                            addCount: 0,
                            lastBulkTrigger: null,
                            products: []
                        };
                        values_hidden_shops.value[i] = shopId;
                        // Prefill products
                        let shopTotal = 0;
                        for (let j = 0; j < details.length; j++) {
                            const d = details[j];
                            const p = {
                                id: Date.now() + j,
                                pmodel: d.product_id,
                                ptype: d.packing_type || 'boxes',
                                quantity: d.quantity,
                                hidden_val: d.product_id,
                                total_amount: d.total_amount,
                                discount: d.discount != null ? d.discount : "",
                                discount_type: d.discount_type || 'price',
                            };
                            shopTotal += parseFloat(d.total_amount);
                            newShop.products.push(p);
                        }
                        newShop.total_amount = shopTotal.toFixed(2);
                        shops.value.push(newShop);
                        // Prefer values from show() if present; otherwise fetch per-shop stats
                        if (typeof row.discount !== 'undefined') newShop.discount = row.discount;
                        if (typeof row.freight !== 'undefined') newShop.freight = row.freight;
                        if (typeof row.amount !== 'undefined') newShop.amount = row.amount;
                        if (newShop.discount === '' || newShop.freight === '' || newShop.amount === '') {
                            try {
                                const statRes = await billingServices.getDetailShopPdfContent(billingId.value, shopId);
                                const stats = statRes.data && statRes.data.stats ? statRes.data.stats : null;
                                if (stats) {
                                    if (newShop.discount === '') newShop.discount = stats.discount || '';
                                    if (newShop.freight === '') newShop.freight = stats.freight || '';
                                    if (newShop.amount === '') newShop.amount = stats.received || '';
                                }
                            } catch (e) { void 0; }
                        }
                        try {
                            const prevRes = await BalanceSheetServices.getPrevBalance(shopId, salesman_id.value);
                            newShop.prev_balance = prevRes.data.remaining_amount;
                        } catch (e) { void 0; }
                    }
                } catch (e) {
                    // If anything fails, keep in add mode
                    console.error(e);
                }
            }
        });

        const onSubmit = async (values) => {
            loader.value = true;
            searchDisabled.value = true;

            // The billing-date dropdown applies to the "initial" and "middle" sale
            // types. If no date is picked, send it empty — the backend bills as today.
            const billingDate = (sale_type.value === 'initial' || sale_type.value === 'middle') && billing_date.value
                ? moment(billing_date.value).format('YYYY-MM-DD')
                : "";
            let payload = {
                "billingData": values.shops,
                "salesmanId": values.salesman_id,
                "saleType": values.sale_type,
                "companyId": values.company_id || "",
                "billingDate": billingDate
            }
            if (salesman_id.value === 0) {
                payload = {
                    "billingData": values.shops,
                    "salesmanId": "",
                    "saleType": "",
                    "billingDate": billingDate
                }
            }
            if (sale_type.value === "") {
                payload = {
                    "billingData": values.shops,
                    "salesmanId": "",
                    "saleType": values.salesman_id,
                    "billingDate": billingDate
                }
            }
            if (isEdit.value && billingId.value) {
                await billingServices.updateBilling(billingId.value, payload)
                    .then(async () => {
                        resetCustomForm();
                        loader.value = false;
                        searchDisabled.value = false;
                        router.push('/billing');
                    })
                    .catch(error => {
                        loader.value = false;
                        searchDisabled.value = false;
                        if (error.response && error.response.status == 422) {
                            errors_v.record(error.response.data.errors || {});
                            focusFirstQuantityError(error.response.data.errors);
                            showErrorGrowl(error.response.data.message || 'Unable to update billing');
                        }
                    });
            } else {
                await billingServices.addBilling(payload)
                    .then(async () => {
                        resetCustomForm();
                        loader.value = false;
                        searchDisabled.value = false;
                        router.push('/billing');
                    })
                    .catch(error => {
                        loader.value = false;
                        searchDisabled.value = false;
                        if (error.response && error.response.status == 422) {
                            errors_v.record(error.response.data.errors);
                            focusFirstQuantityError(error.response.data.errors);
                            // Surface server messages (e.g. the duplicate-billing conflict).
                            if (error.response.data.message) {
                                showErrorGrowl(error.response.data.message);
                            }
                        }
                    });
            }
        }

        const selectFocus = ref(false);



        const balance = ref("");
        const amountModal = ref("");
        const paymentModal = ref("");

        return {
            selectFocus,



            balance,
            amountModal,
            paymentModal,



            shops,
            add_shop,
            remove_shop,
            changeMultiselectShop,
            salesmen,
            salesman_id,
            sale_type,
            billing_date,
            dateOptions,
            shopOptions,
            productOptions,
            filteredProductOptions,
            companies,
            company_id,
            onSubmit,
            values_hidden_shops,
            add_product,
            remove_product,
            changeMultiselectProduct,
            errors_v,
            schema,
            resetCustomForm,
            loader,
            searchDisabled,
            editLocked,
            router,
            route,
            isEdit,
            showGrowl,
            alert_m,
            growlMessage,
            updateTotalAmount,
            onDiscountInput,
            bulkAddProducts,
            setAddCountRef,
            myForm,

        }
    }
}
</script>
